import { forwardRef } from 'react';
import { formatCurrency, formatMonth, getPaymentTypeLabel, getStatusLabel } from '../lib/utils';
import { receiptStyles } from './receiptStyles';

const formatDate = (value, withTime = false) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('id-ID', {
    timeZone: 'Asia/Jakarta', day: 'numeric', month: 'long', year: 'numeric',
    ...(withTime ? { hour: '2-digit', minute: '2-digit' } : {})
  }).format(date);
};

const Receipt = forwardRef(({ receipt }, ref) => {
  if (!receipt) return null;
  const { payment, tenant, kost, bank_accounts = [] } = receipt;
  const paid = payment.status === 'lunas';
  return (
    <article ref={ref} className="kc-receipt" aria-label="Kuitansi pembayaran Kos Cemara">
      <style>{receiptStyles}</style>
      <header className="kc-receipt-header kc-receipt-no-break">
        <img className="kc-receipt-logo" src={`${window.location.origin}/logo-original.png`} alt="Logo Kos Cemara" />
        <div>
          <p className="kc-receipt-brand">{kost?.name || 'Kos Cemara'}</p>
          <p className="kc-receipt-contact">koscemara.com<br />koscemara22@gmail.com</p>
        </div>
      </header>
      <section className="kc-receipt-heading kc-receipt-no-break">
        <div><p className="kc-receipt-eyebrow">Administrasi hunian</p><h1>Kuitansi pembayaran</h1></div>
        <span className={`kc-receipt-status${paid ? '' : ' pending'}`}>{getStatusLabel(payment.status)}</span>
      </section>
      <section className="kc-receipt-meta kc-receipt-no-break">
        <div><span className="kc-receipt-label">Nomor kuitansi</span><span className="kc-receipt-value">{receipt.receipt_number}</span></div>
        <div><span className="kc-receipt-label">Tanggal dokumen</span><span className="kc-receipt-value">{formatDate(receipt.date)}</span></div>
      </section>
      <section className="kc-receipt-parties kc-receipt-no-break">
        <div>
          <span className="kc-receipt-label">Nama penghuni</span><p className="kc-receipt-name">{tenant.name}</p>
          {tenant.id_number && <p className="kc-receipt-detail">No. identitas: {tenant.id_number}</p>}
          {tenant.phone && <p className="kc-receipt-detail">Telepon: {tenant.phone}</p>}
        </div>
        <div><span className="kc-receipt-label">Hunian & periode</span><p className="kc-receipt-name">{tenant.room_name}</p><p className="kc-receipt-detail">{formatMonth(payment.month)}</p></div>
      </section>
      <section>
        <h2 className="kc-receipt-section">Rincian pembayaran</h2>
        <table className="kc-receipt-table">
          <thead><tr><th scope="col">Keterangan</th><th scope="col">Nominal</th></tr></thead>
          <tbody><tr><td><div className="kc-receipt-item">{getPaymentTypeLabel(payment.payment_type)}</div>{payment.description && <p className="kc-receipt-description">{payment.description}</p>}</td><td>{formatCurrency(payment.amount)}</td></tr></tbody>
        </table>
      </section>
      <section className="kc-receipt-total kc-receipt-no-break"><span className="kc-receipt-total-label">Total pembayaran</span><strong className="kc-receipt-total-amount">{formatCurrency(payment.amount)}</strong></section>
      {bank_accounts.length > 0 && <section className="kc-receipt-bank"><h2 className="kc-receipt-section">Rekening resmi Kos Cemara</h2>{bank_accounts.map((account, index) => <p key={account.id || index} className="kc-receipt-no-break"><strong>{account.bank_name} · {account.account_number}</strong><br />a.n. {account.account_holder}</p>)}</section>}
      <p className="kc-receipt-note">{paid ? 'Pembayaran telah tercatat. Terima kasih atas kepercayaan Anda kepada Kos Cemara.' : 'Pembayaran belum dikonfirmasi lunas. Dokumen ini bukan konfirmasi pelunasan.'}<br />Simpan dokumen ini sebagai arsip Anda.</p>
      <section className="kc-receipt-signatures kc-receipt-no-break"><div><p>Penghuni</p><div className="kc-receipt-sign-line">{tenant.name}</div></div><div><p>Diterima oleh</p><div className="kc-receipt-sign-line">Tim Kos Cemara</div></div></section>
      <footer className="kc-receipt-footer kc-receipt-no-break"><strong>Kos Cemara · Nyaman dihuni, mudah diakses.</strong><span>Dicetak: {formatDate(new Date(), true)} WIB</span></footer>
    </article>
  );
});
Receipt.displayName = 'Receipt';
export default Receipt;
